import { LoyaltyBasketItem } from '@libs/common-node';

import { cweaClient } from '../clients/api-proxy-browser-client';
import { CWEA_ENDPOINTS } from '../constants';

type TreatPointsBody = {
    sku: string;
    price: number;
    quantity: number;
};

export async function getTreatPoints<T>({ sku, price, quantity }: TreatPointsBody): Promise<Nullable<T>> {
    const url = CWEA_ENDPOINTS.treatPoints.get();

    return await cweaClient.post<T, LoyaltyBasketItem[]>(url, {
        body: [
            {
                productSku: sku,
                productQuantity: quantity,
                qualifyingPrice: price,
            },
        ],
        useOldFetch: true,
    });
}
